// components/Navbar/Navbar.js
'use client';
import React, { useState } from "react";
import Link from "next/link";

// react-i18next o‘rniga o‘z hook'ingizni chaqirasiz
import { useLanguage } from "@/app/contexts/LanguageContext"; 

import DesktopNavbar from "./DesktopNavbar";
import MobileNavbar from "./MobileNavbar";
import { useSearch } from "./hook/useSearch";

const Navbar = () => {
  const { t } = useLanguage(); // Custom hookdan t ni olamiz
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  // Custom search hook
  const searchProps = useSearch();

  return (
    <nav className="px-4 md:px-[100px] py-2 mb-2 fixed top-0 left-0 right-0" style={{ zIndex: 9999 }}>
      {/* Orqa fon gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-transparent backdrop-blur-[60px]"></div>

      <div className="relative flex justify-between items-center" style={{ zIndex: 10000 }}>
        {/* Logo */}
        <Link href="/main">
          <div className="logo_box">
            <img className="w-[80px] md:w-[108px]" src="/logo.png" alt="Logo" />
          </div>
        </Link>

        {/* Desktop navigatsiya */}
        <div className="hidden md:flex gap-8">
          <DesktopNavbar 
            t={t}
            searchProps={searchProps}
          />
        </div>

        {/* Mobil navigatsiya */}
        <div className="md:hidden">
          <MobileNavbar 
            t={t}
            isSearchOpen={isSearchOpen}
            setIsSearchOpen={setIsSearchOpen}
            searchProps={searchProps}
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
